<template>
  <div id="printMeQrCode" style="position: relative">
    <p class="card-subtitle">{{ data.prefecture_social_name }}</p>
    <p class="card-subtitle">{{ data.sec_name }}</p>
    <p class="card-subtitle">Veículo: {{ data.model_desc }}</p>
    <p class="card-subtitle">Placa: {{ data.vehicle_board }}</p>
    <p class="card-subtitle">Senha: {{ data.vehicle_password }}</p>
    <img
      src="@/assets/card.png"
      style="width: 102.9mm; height: 70.4mm; position: relative"
    />
    <img
      v-if="data.prefecture_logo"
      :src="$store.state.urlImages + data.prefecture_logo"
      style="
        width: 25mm;
        height: 25mm;
        position: absolute;
        top: 110px;
        left: 275px;
      "
    />
    <div
      style="
        width: 40mm;
        height: 16mm;
        position: relative;
        bottom: 43mm;
        left: 80px;
      "
    >
      <img
        :src="
          `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${data.vehicle_password}`
        "
        alt=""
        :title="data.vehicle_password"
        width="100"
        height="100"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style></style>
